export default "__VITE_ASSET__CzxLx7mJ__"